"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SizerPlaceholder = _interopRequireDefault(require("./SizerPlaceholder"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Sizer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Sizer, _React$PureComponent);

  function Sizer(props) {
    var _this;

    _classCallCheck(this, Sizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sizer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "DEBOUNCE_TIMER", 300);

    _defineProperty(_assertThisInitialized(_this), "countElementsToHide", function () {
      var container = _this.containerRef.current;

      var _this$props$getBoundi = _this.props.getBoundingClientRect(container),
          containerX = _this$props$getBoundi.x,
          containerWidth = _this$props$getBoundi.width;

      return _toConsumableArray(container.children).filter(function (item, index) {
        var _this$props$getBoundi2 = _this.props.getBoundingClientRect(item),
            itemX = _this$props$getBoundi2.x,
            itemWidth = _this$props$getBoundi2.width;

        return itemX + itemWidth > containerX + containerWidth;
      }).length;
    });

    _defineProperty(_assertThisInitialized(_this), "updateHiddenCounter", function () {
      _this.setState(function (prevState) {
        return {
          hiddenCounter: prevState.hiddenCounter + _this.countElementsToHide(),
          showPlaceholder: false
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedUpdateHiddenCounter", (0, _lodash2.default)(_this.updateHiddenCounter, _this.DEBOUNCE_TIMER));

    _this.containerRef = _react.default.createRef();
    _this.state = {
      hiddenCounter: 0,
      showPlaceholder: true
    };
    return _this;
  }

  _createClass(Sizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateHiddenCounter();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.debouncedUpdateHiddenCounter.cancel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!(0, _lodash.default)(prevProps, this.props)) {
        this.setState({
          hiddenCounter: 0,
          showPlaceholder: true
        }, this.debouncedUpdateHiddenCounter());
      }

      if (prevState.hiddenCounter !== this.state.hiddenCounter) {
        this.setState({
          showPlaceholder: true
        }, this.debouncedUpdateHiddenCounter());
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          useLoadingPlaceholder = _this$props.useLoadingPlaceholder,
          remainderElement = _this$props.remainderElement,
          width = _this$props.width;
      var _this$state = this.state,
          hiddenCounter = _this$state.hiddenCounter,
          showPlaceholder = _this$state.showPlaceholder;

      var processedChildren = _react.default.Children.toArray(children).slice(0, _react.default.Children.count(children) - hiddenCounter);

      return _react.default.createElement("div", {
        ref: this.containerRef,
        style: {
          width: width,
          position: 'relative',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        }
      }, processedChildren, hiddenCounter && remainderElement ? remainderElement(hiddenCounter) : null, useLoadingPlaceholder ? _react.default.createElement(_SizerPlaceholder.default, {
        visible: showPlaceholder
      }) : null);
    }
  }]);

  return Sizer;
}(_react.default.PureComponent);

Sizer.defaultProps = {
  useLoadingPlaceholder: true,
  remainderElement: function remainderElement(nrHiddenElements) {
    return null;
  },
  getBoundingClientRect: function getBoundingClientRect(node) {
    return node.getBoundingClientRect();
  }
};
Sizer.propTypes = {
  children: _propTypes.any,

  /** Should come from @@<Autosizer>@@ */
  width: _propTypes.number,
  useLoadingPlaceholder: _propTypes.bool,
  getBoundingClientRect: _propTypes.func,

  /** Function that expects the number of occluded elements as parameter. Should return the element that is meant to be displayed in place of those elements. */
  remainderElement: _propTypes.func
};
var _default = Sizer;
exports.default = _default;
Sizer.__docgenInfo = {
  "description": "Sizer component is expected to be used with Autosizer",
  "methods": [{
    "name": "countElementsToHide",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "updateHiddenCounter",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Sizer",
  "props": {
    "useLoadingPlaceholder": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "remainderElement": {
      "defaultValue": {
        "value": "nrHiddenElements => null",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function that expects the number of occluded elements as parameter. Should return the element that is meant to be displayed in place of those elements."
    },
    "getBoundingClientRect": {
      "defaultValue": {
        "value": "node => node.getBoundingClientRect()",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "width": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Should come from @@<Autosizer>@@"
    }
  }
};